
export default  {
  name: 'SidebarItem',
  components: {  },
  props: {
    backgroundColor: {
      type: String,
      default: '#FFFFFF'
    },
    fontColor: {
      type: String,
      default: '#FFFFFF'
    },
    list: {
      type: Array,
      default: () => ([])
    }
  },
  methods: {
    toLinkPath(item) {
      this.$emit('close')
      return this.$router.push({
        path: item.path
      })
    }
  }
}
